import BaseModelAPI from '../BaseModelAPI';

export default class ReceiptFromProductionCaseSourceList extends BaseModelAPI {

	static entity = 'receiptfromproductioncasesourcelist'
	static entityName = 'receiptfromproductioncasesource';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
